<template>
  <v-container v-if="prefisso == 'ferraraquarzi'" fluid>
    <v-toolbar color="indigo" dense class="rounded rounded-b-0 mt-5">
      <v-toolbar-title class="white--text"> Luoghi </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="addLuogo" v-bind="attrs" v-on="on" small>
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Agg. luogo</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-15" @click="saveConfig" v-bind="attrs" v-on="on" small>
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip> -->
      <v-spacer />
    </v-toolbar>
    <v-data-table :headers="headers" fixed-header :items="items_luoghi" class="elevation-1">
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="editItem(item)">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.partenza_default`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :color="item.partenza_default ? 'success' : 'error'">{{
              item.partenza_default ? 'mdi-check' :
              'mdi-close-circle'}}</v-icon>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.abilita_marker`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :color="item.abilita_marker ? 'success' : 'error'">{{ item.abilita_marker ?
              'mdi-check' : 'mdi-close-circle' }}</v-icon>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.fine_giornata`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :color="item.fine_giornata ? 'success' : 'error'">{{ item.fine_giornata ?
              'mdi-check' : 'mdi-close-circle' }}</v-icon>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.magazzino`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :color="item.magazzino ? 'success' : 'error'">{{ item.magazzino ?
              'mdi-check' : 'mdi-close-circle' }}</v-icon>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small @click="deleteItem(item)">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_add_luogo" width="70%">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">{{ luogo_sel.id_azienda_sede != -1 ? 'Modifica Luogo' : 'Crea Luogo'
            }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="saveLuogo" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="chiudiDialogLuogo" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-card-text>
            <b>Località</b>
          </v-card-text>
          <v-row justify="center">

            <v-col cols="4">
              <v-text-field v-model="luogo_sel.descrizione" label="Nome Luogo" dense hide-details />
            </v-col>
            <v-col cols="5">
              <v-text-field v-model="luogo_sel.indirizzo" label="Indirizzo" dense hide-details />
            </v-col>
            <v-col cols="1">
              <v-text-field v-model.number="luogo_sel.civico" label="N°" type="number" dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field v-model.number="luogo_sel.cap" label="CAP" type="number" dense hide-details />
            </v-col>

            <!-- Regione partenza. -->
            <v-col cols="4">
              <v-autocomplete dense hide-details label="Regione" item-text="regione" item-value="id_regione"
                v-model.number="luogo_sel.id_regione" :items="items_regioni" @change="luogo_sel.id_comune = null;
                luogo_sel.id_provincia = null;
                getProvince(luogo_sel.id_regione)" />
            </v-col>

            <!-- Provincia partenza. -->
            <v-col cols="4">
              <v-autocomplete dense hide-details label="Provincia" item-text="provincia" item-value="id_provincia"
                v-model.number="luogo_sel.id_provincia" :items="items_province" :readonly="!luogo_sel.id_regione"
                @click="!luogo_sel.id_regione ? message('Selezionare una regione') : ''" @change="(id) => {
                  luogo_sel.id_comune = null;
                  getComuni(luogo_sel.id_provincia);
                  let item = this.items_province.find((e) => { return e.id_provincia == id });
                  this.luogo_sel.provincia = item ? item.sigla : null;
                }" />
            </v-col>

            <!-- Comune partenza. -->
            <v-col cols="4">
              <v-autocomplete dense hide-details label="Comune" item-text="comune" item-value="id_comune"
                v-model.number="luogo_sel.id_comune" :items="items_comuni" :readonly="!luogo_sel.id_provincia"
                @click="!luogo_sel.id_provincia ? message('Selezionare una provincia') : ''" @change="(id) => {
                  let item = this.items_comuni.find((e) => { return e.id_comune == id });
                  this.luogo_sel.localita = item ? item.comune : null;
                }" />
            </v-col>


          </v-row>
          <v-row>

            <!-- <v-col cols="6">
              <v-card-text class="d-flex justify-center">
                <b>Tempo setup</b>
              </v-card-text>
              <v-row justify="center">
                <v-col cols="6">
                  <v-text-field v-model.number="selected_item.tempo_setup_partenza" label="Partenza(minuti)"
                    type="number" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model.number="selected_item.tempo_setup_arrivo" label="Arrivo(minuti)" type="number"
                    dense hide-details />
                </v-col>
              </v-row>
            </v-col> -->
            <v-col>
                <v-checkbox label="Magazzino" v-model="luogo_sel.magazzino" />
            </v-col>
            <v-col>
                <v-checkbox label="Fine giornata" v-model="luogo_sel.fine_giornata" />
            </v-col>
            <v-col>
                <v-checkbox label="Abilita come partenza" v-model="luogo_sel.partenza_default" />
            </v-col>
            <v-col>
                <v-checkbox label="Abilita marker sulla mappa" v-model="luogo_sel.abilita_marker" />
            </v-col>
          </v-row>

        </v-container>
      </v-card>
    </v-dialog>


    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-container>


  <!-- CONTAINER PARTENZA -->
  <v-container v-else fluid>
    <v-toolbar color="indigo" dense class="rounded rounded-b-0 mt-5">
      <v-toolbar-title class="white--text"> Partenza </v-toolbar-title>
      <v-spacer />
      <!-- Pulsante apri dialog -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-15" @click="saveConfig" v-bind="attrs" v-on="on" small>
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <v-spacer />
    </v-toolbar>
    <v-card-text class="d-flex justify-center pt-5">
      <b>Località</b>
    </v-card-text>
    <v-row class="mx-1" justify="center">

      <!-- Regione partenza. -->
      <v-col cols="3">
        <v-autocomplete dense hide-details label="Regione" item-text="regione" item-value="id_regione"
          v-model.number="selected_item.id_regione_default" :items="items_regioni" @change="selected_item.id_comune_default = null;
          selected_item.id_provincia_default = null;
          getProvince(selected_item.id_regione_default)" />
      </v-col>

      <!-- Provincia partenza. -->
      <v-col cols="3">
        <v-autocomplete dense hide-details label="Provincia" item-text="provincia" item-value="id_provincia"
          v-model.number="selected_item.id_provincia_default" :items="items_province"
          :readonly="!selected_item.id_regione_default"
          @click="!selected_item.id_regione_default ? message('Selezionare una regione') : ''" @change="(id) => {
            selected_item.id_comune_default = null;
            getComuni(selected_item.id_provincia_default);
            let item = this.items_province.find((e) => { return e.id_provincia == id });
            this.selected_item.provincia_partenza = item ? item.sigla : null;
          }" />
      </v-col>

      <!-- Comune partenza. -->
      <v-col cols="3">
        <v-autocomplete dense hide-details label="Comune" item-text="comune" item-value="id_comune"
          v-model.number="selected_item.id_comune_default" :items="items_comuni"
          :readonly="!selected_item.id_provincia_default"
          @click="!selected_item.id_provincia_default ? message('Selezionare una provincia') : ''" @change="(id) => {
            let item = this.items_comuni.find((e) => { return e.id_comune == id });
            this.selected_item.localita_partenza = item ? item.comune : null;
          }" />
      </v-col>

      <v-col cols="4">
        <v-text-field v-model="selected_item.indirizzo_partenza" label="Indirizzo" dense hide-details />
      </v-col>
      <v-col cols="1">
        <v-text-field v-model.number="selected_item.civico_partenza" label="N°" type="number" dense hide-details />
      </v-col>
      <v-col cols="1">
        <v-text-field v-model.number="selected_item.cap_partenza" label="CAP" type="number" dense hide-details />
      </v-col>
    </v-row>
    <v-card-text class="mt-6 d-flex justify-center">
      <b>Tempo setup</b>
    </v-card-text>
    <v-row justify="center" align="center">
      <v-col cols="2">
        <v-text-field v-model.number="selected_item.tempo_setup_partenza" label="Partenza (minuti)" type="number" dense
          hide-details />
      </v-col>
      <v-col cols="2">
        <v-text-field v-model.number="selected_item.tempo_setup_arrivo" label="Arrivo (minuti)" type="number" dense
          hide-details />
      </v-col>
      <v-col cols="2">
        <v-text-field v-model.number="selected_item.tolleranza" label="Tolleranza fine orario lavoro (minuti)" type="number" dense hide-details />
      </v-col>
      <v-col cols="2">
        <v-text-field v-model.number="selected_item.soglia_padding" label="Padding Sovrapposizione (minuti)" type="number" dense
          hide-details />
      </v-col>
      <!-- <v-col cols="2">
        <v-checkbox disabled label="Services Overlapping" :true-value="1" :false-value="0"
          v-model.number="selected_item.services_overlapping" />
      </v-col> -->
      <v-col cols="2">
        <v-checkbox label="Visibilità Slot" :true-value="1" :false-value="0"
          v-model.number="selected_item.visibilita_slot" />
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Config {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_config", default_val: null },
      { nome: "id_regione_default", default_val: null },
      { nome: "id_provincia_default", default_val: null },
      { nome: "id_comune_default", default_val: null },
      { nome: "localita_partenza", default_val: "" },
      { nome: "provincia_partenza", default_val: "" },
      { nome: "indirizzo_partenza", default_val: "" },
      { nome: "civico_partenza", default_val: "" },
      { nome: "cap_partenza", default_val: "" },
      { nome: "tempo_setup_partenza", default_val: null },
      { nome: "tempo_setup_arrivo", default_val: null },
      { nome: "colore_righe_alternato", default_val: null },
      { nome: "nome_operatori", default_val: null },
      { nome: "tipo_schedulazione", default_val: "" },
      { nome: "vista_iniziale", default_val: "" },
      { nome: "aspetto_fase", default_val: null },
      { nome: "unita_tempo", default_val: "" },
      { nome: "abilita_marker", default_val: false },
      { nome: "visibilita_slot", default_val: false },
      { nome: "services_overlapping", default_val: false },
      { nome: "soglia_padding", default_val: null },
      { nome: "tolleranza", default_val: null },
    ];

    return campi;
  }
}

class Luogo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_azienda_sede", default_val: null },
      { nome: "id_azienda", default_val: 1 },
      { nome: "descrizione", default_val: "" },
      { nome: "localita", default_val: "" },
      { nome: "provincia", default_val: "" },
      { nome: "cap", default_val: "" },
      { nome: "indirizzo", default_val: "" },
      { nome: "civico", default_val: "" },
      { nome: "latitudine", default_val: null },
      { nome: "longitudine", default_val: null },
      { nome: "id_regione", default_val: null },
      { nome: "id_provincia", default_val: null },
      { nome: "id_comune", default_val: null },
      { nome: "partenza_default", default_val: false },
      { nome: "abilita_marker", default_val: false },
      { nome: "magazzino", default_val: false },
      { nome: "fine_giornata", default_val: false },
      { nome: "validita", default_val: 1 }
    ];

    return campi;
  }
}
export default {
  name: "QLPartenza",
  components: { SnackbarQV },
  data() {
    return {
      // Variabili d'appoggio
      prefisso: localStorage.prefisso_user,
      selected_item: new Config(),
      luogo_sel: new Luogo(),

      // Modal
      dialog_add_luogo: false,
      overlay: false,

      //   Array
      items_luoghi: [],
      items_regioni: [],
      items_province: [],
      items_comuni: [],
      headers: [
        {
          text: "Modifica",
          value: "modifica",
          filterable: false,
          sortable: false,
        },
        {
          text: "Default Partenza",
          value: "partenza_default",
          filterable: false,
          sortable: false,
        },
        {
          text: "Default Mappa",
          value: "abilita_marker",
          filterable: false,
          sortable: false,
        },
        {
          text: "Fine Giornata",
          value: "fine_giornata",
          filterable: false,
          sortable: false,
        },
        {
          text: "Magazzino",
          value: "magazzino",
          filterable: false,
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "descrizione",
          filterable: false,
          sortable: false,
        },
        {
          text: "Località",
          value: "localita",
          filterable: false,
          sortable: false,
        },
        {
          text: "Indirizzo",
          value: "indirizzo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          filterable: false,
          sortable: false,
        },
      ],
    };
  },
  methods: {
    addLuogo() {
      this.dialog_add_luogo = true;
    },
    chiudiDialogLuogo() {
      this.dialog_add_luogo = false; 
      this.luogo_sel = new Luogo();
    },
    editItem(arg) {
      this.luogo_sel = new Luogo(arg);
      this.luogo_sel.abilita_marker = this.luogo_sel.abilita_marker == 0 ? false : true;
      this.luogo_sel.partenza_default = this.luogo_sel.partenza_default == 0 ? false : true;
      this.luogo_sel.magazzino = this.luogo_sel.magazzino == 0 ? false : true;
      this.luogo_sel.fine_giornata = this.luogo_sel.fine_giornata == 0 ? false : true;
      this.getProvince(this.luogo_sel.id_regione);
      this.getComuni(this.luogo_sel.id_provincia);
      this.dialog_add_luogo = true;
    },
    deleteItem(arg) {
      this.luogo_sel = new Luogo(arg);
      this.luogo_sel.validita = 0;
      this.saveLuogo()
    },
    getLuoghi() {
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getsedifiliali",
          id_regione: null,
          id_provincia: null,
          id_comune: null
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getconfig).then((res) => {
        this.overlay = false;
        if (res.status === 200 || res.status === 204) {
          this.items_luoghi = res.data.result;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    saveConfig() {
      const saveconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "saveconfig",
          token: localStorage.getItem("user_token"),
          config: this.selected_item,
        },
      };

      this.overlay = true;
      this.$store.dispatch("api", saveconfig)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.selected_item = res.data.result;
            this.$refs.SnackbarQV.print("success", "Configurazione salvata con successo.");
          } else {
            this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });
    },
    saveLuogo() {
      this.luogo_sel.abilita_marker = this.luogo_sel.abilita_marker == true ? 1 : 0;
      this.luogo_sel.partenza_default = this.luogo_sel.partenza_default == true ? 1 : 0;
      this.luogo_sel.fine_giornata = this.luogo_sel.fine_giornata == true ? 1 : 0;
      this.luogo_sel.magazzino = this.luogo_sel.magazzino == true ? 1 : 0;
      this.overlay = true;
      const request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "saveaziendasede",
          token: localStorage.getItem("user_token"),
          sede: this.luogo_sel,
        },
      };


      this.$store.dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.dialog_add_luogo = false;
            this.luogo_sel = new Luogo();
            this.getLuoghi();
          } else {
            this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });
    },
    message(message) {
      this.$refs.SnackbarQV.print("orange", message);
    },

    getConfig() {
      const getconfig = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getconfig",
        },
      };

      this.overlay = true;

      this.$store.dispatch("api", getconfig)
        .then((res) => {
          this.overlay = false;
          this.getRegioni();

          if (res.status === 200) {
            if (this.prefisso == 'ferraraquarzi') {
              this.items_luoghi.push(res.data.result)
            } else {
              this.selected_item = res.data.result;
              this.getProvince(this.selected_item.id_regione_default);
              this.getComuni(this.selected_item.id_provincia_default);
            }

          } else this.$refs.SnackbarQV.print("orange", `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`);

        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });
    },

    getRegioni() {
      // Chiamata per prendere le regioni.
      const getregioni = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getregioni",
        },
      };

      this.overlay = true;
      this.$store.dispatch("api", getregioni).then((res) => {
        this.overlay = false;
        if (res.status == 200) this.items_regioni = res.data.result ? res.data.result : [];
        else this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
      })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });
    },

    getProvince(id_regione) {
      // Chiamata per prendere le province legate alla regione.
      if (!id_regione) return;

      let getprovince = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getprovince",
          id_regione: id_regione
        },
      };

      this.overlay = true;

      this.$store.dispatch("api", getprovince).then((res) => {
        this.overlay = false;
        if (res.status == 200) this.items_province = res.data.result ? res.data.result : [];
        else this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
      })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });

    },

    getComuni(id_provincia) {
      // Chiamata per prendere i comuni legati alla provincia.
      if (!id_provincia) return;

      let getcomuni = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getcomuni",
          id_provincia: id_provincia
        },
      };

      // Assegna l'ID provincia alla chiamata solo se parametro esiste.
      this.overlay = true;

      this.$store.dispatch("api", getcomuni).then((res) => {
        this.overlay = false;
        if (res.status == 200) this.items_comuni = res.data.result ? res.data.result : [];
        else this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
      })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        });
    }
  },

  created() { },
  mounted() {
    if (this.prefisso == 'ferraraquarzi') {
      this.getLuoghi();
    } else {
      this.getConfig();
    }

    this.getRegioni();
  },
};
</script>
<style scoped></style>